export const isExportToFlamegraphDotComEnabled = true;
export const isAnnotationsEnabled = true;
